export default __webpack_public_path__ + "static/media/ilha_6.1fe60792.jpg";